import styles from './SignupUserContainer.module.css'

type SignupUserContainerProps = {
  leftContent: React.ReactNode
  rightContent: React.ReactNode
  bottomContent?: React.ReactNode
}

const SignupUserContainer = ({ leftContent, rightContent, bottomContent }: SignupUserContainerProps) => (
  <div className={styles.container}>
    <div className={styles.top}>
      <div className={styles.left}>{leftContent}</div>

      <div className={styles.right}>{rightContent}</div>
    </div>
    {bottomContent && <div className={styles.bottom}>{bottomContent}</div>}
  </div>
)

export default SignupUserContainer
